export const BASE_API_URL: string = process.env.REACT_APP_BOT_URL as string;
